var React = require('react');

function Coins232px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M23 32a8.977 8.977 0 0 1-3.107-.568A.994.994 0 0 1 19 32H3a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h2v-3H4a1 1 0 0 1-1-1v-4H1a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1h2V7H2a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h17a1 1 0 0 1 1 1v4h1a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-2v2.946A9.028 9.028 0 0 1 23 14c4.963 0 9 4.037 9 9s-4.037 9-9 9zM4 27v3h13.352a8.945 8.945 0 0 1-2.398-3H4zm10.059-5H7v3h7.234A8.988 8.988 0 0 1 14 23c0-.34.024-.67.059-1zM5 20h9.536a8.968 8.968 0 0 1 1.445-2.626 2.66 2.66 0 0 1 .312-.371l.002-.003H5v3zm-3-8v3h15v-3H2zM18 2H3v3h15V2zm2 8V7H5v3h15zm3 6a6.987 6.987 0 0 0-5.249 2.371 1.496 1.496 0 0 0-.172.202c-.85 1.063-1.365 2.273-1.527 3.553a7.064 7.064 0 0 0 .458 3.504 6.948 6.948 0 0 0 2.112 2.827A7.016 7.016 0 0 0 23 30c3.859 0 7-3.14 7-7s-3.141-7-7-7zm0 12a5.019 5.019 0 0 1-4.637-3.124 5.044 5.044 0 0 1-.327-2.494 5.009 5.009 0 0 1 1.065-2.509c.036-.051.11-.143.192-.225C20.195 18.618 21.563 18 23 18c2.757 0 5 2.243 5 5s-2.243 5-5 5zm0-8c-.862 0-1.683.37-2.249 1.014-.01.014-.082.1-.092.113a2.993 2.993 0 0 0 .462 4.21A3.012 3.012 0 0 0 23 26c1.654 0 3-1.346 3-3s-1.346-3-3-3z","key":1})]);
}

Coins232px.displayName = "Coins232px";

Coins232px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 32 32"};

module.exports = Coins232px;

Coins232px.default = Coins232px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/coins-2-32px.svg
// module id = 1092
// module chunks = 0